@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_088_067_404)
internal val Res.string.feature_poll_subtitle: StringResource by lazy {
      StringResource("string:feature_poll_subtitle", "feature_poll_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162673, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 160097, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 162137, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 153977, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150545, 117),
      ))
    }

@delegate:ResourceContentHash(-2_110_870_359)
internal val Res.string.feature_poll_title: StringResource by lazy {
      StringResource("string:feature_poll_title", "feature_poll_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162823, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 160223, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 162271, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 154111, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150663, 62),
      ))
    }

@delegate:ResourceContentHash(328_855_558)
internal val Res.string.feature_unavailable_ok: StringResource by lazy {
      StringResource("string:feature_unavailable_ok", "feature_unavailable_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162898, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 160286, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 162334, 34),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 154174, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150726, 34),
      ))
    }

@delegate:ResourceContentHash(752_259_176)
internal val Res.string.feature_unavailable_web_text: StringResource by lazy {
      StringResource("string:feature_unavailable_web_text", "feature_unavailable_web_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 162933, 168),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 160321, 160),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 162369, 180),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 154209, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150761, 144),
      ))
    }

@delegate:ResourceContentHash(-1_085_216_081)
internal val Res.string.feature_unavailable_web_title: StringResource by lazy {
      StringResource("string:feature_unavailable_web_title", "feature_unavailable_web_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 163102, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 160482, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 162550, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 154354, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150906, 61),
      ))
    }

@delegate:ResourceContentHash(1_372_617_344)
internal val Res.string.feedback_general_subject: StringResource by lazy {
      StringResource("string:feedback_general_subject", "feedback_general_subject", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 163168, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 160544, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 154424, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 150968, 56),
      ))
    }

@delegate:ResourceContentHash(-1_986_658_050)
internal val Res.string.feedback_general_template: StringResource by lazy {
      StringResource("string:feedback_general_template", "feedback_general_template", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 163225, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 160601, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 154481, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151025, 69),
      ))
    }

@delegate:ResourceContentHash(2_112_521_742)
internal val Res.string.feedback_quiz_error_subject: StringResource by lazy {
      StringResource("string:feedback_quiz_error_subject", "feedback_quiz_error_subject", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 163303, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 160683, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 154555, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151095, 75),
      ))
    }

@delegate:ResourceContentHash(-1_993_452_806)
internal val Res.string.feedback_quiz_error_template: StringResource by lazy {
      StringResource("string:feedback_quiz_error_template", "feedback_quiz_error_template", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 163379, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 160771, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 154639, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151171, 84),
      ))
    }

@delegate:ResourceContentHash(1_998_587_510)
internal val Res.string.feedback_update_issue_subject: StringResource by lazy {
      StringResource("string:feedback_update_issue_subject", "feedback_update_issue_subject", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 163464, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 160864, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 154732, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151256, 77),
      ))
    }

@delegate:ResourceContentHash(-1_854_556_503)
internal val Res.string.feedback_update_issue_template: StringResource by lazy {
      StringResource("string:feedback_update_issue_template", "feedback_update_issue_template", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 163550, 138),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 160958, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 154826, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151334, 126),
      ))
    }

@delegate:ResourceContentHash(1_404_305_311)
internal val Res.string.final_quiz_alyn_perfect_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_alyn_perfect_feedback_1", "final_quiz_alyn_perfect_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 163689, 166),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 161101, 158),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 162616, 158),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 154957, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151461, 158),
      ))
    }

@delegate:ResourceContentHash(-186_691_486)
internal val Res.string.final_quiz_alyn_perfect_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_alyn_perfect_feedback_2", "final_quiz_alyn_perfect_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 163856, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 161260, 146),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 162775, 154),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 155112, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151620, 138),
      ))
    }

@delegate:ResourceContentHash(1_363_794_280)
internal val Res.string.final_quiz_alyn_stars0_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_alyn_stars0_feedback_1", "final_quiz_alyn_stars0_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 164003, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 161407, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 162930, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 155251, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151759, 117),
      ))
    }

@delegate:ResourceContentHash(1_076_265_681)
internal val Res.string.final_quiz_alyn_stars0_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_alyn_stars0_feedback_2", "final_quiz_alyn_stars0_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 164137, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 161537, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 163056, 161),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 155369, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151877, 145),
      ))
    }

@delegate:ResourceContentHash(1_489_745_571)
internal val Res.string.final_quiz_alyn_stars1_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_alyn_stars1_feedback_1", "final_quiz_alyn_stars1_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 164283, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 161679, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 163218, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 155511, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152023, 133),
      ))
    }

@delegate:ResourceContentHash(1_158_880_455)
internal val Res.string.final_quiz_alyn_stars1_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_alyn_stars1_feedback_2", "final_quiz_alyn_stars1_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 164433, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 161829, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 163368, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 155653, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152157, 113),
      ))
    }

@delegate:ResourceContentHash(-1_481_513_602)
internal val Res.string.final_quiz_alyn_stars2_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_alyn_stars2_feedback_1", "final_quiz_alyn_stars2_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 164575, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 161967, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 163494, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 155783, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152271, 105),
      ))
    }

@delegate:ResourceContentHash(1_821_762_101)
internal val Res.string.final_quiz_alyn_stars2_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_alyn_stars2_feedback_2", "final_quiz_alyn_stars2_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 164693, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 162097, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 163616, 129),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 155917, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152377, 113),
      ))
    }

@delegate:ResourceContentHash(1_902_980_014)
internal val Res.string.final_quiz_alyn_stars3_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_alyn_stars3_feedback_1", "final_quiz_alyn_stars3_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 164827, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 162219, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 163746, 129),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 156031, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152491, 125),
      ))
    }

@delegate:ResourceContentHash(1_181_413_311)
internal val Res.string.final_quiz_alyn_stars3_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_alyn_stars3_feedback_2", "final_quiz_alyn_stars3_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 164969, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 162365, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 163876, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 156165, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152617, 137),
      ))
    }

@delegate:ResourceContentHash(-401_901_087)
internal val Res.string.final_quiz_corrected_many: StringResource by lazy {
      StringResource("string:final_quiz_corrected_many", "final_quiz_corrected_many", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 165123, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 162515, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 164022, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 156311, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152755, 65),
      ))
    }

@delegate:ResourceContentHash(-855_815_605)
internal val Res.string.final_quiz_corrected_none: StringResource by lazy {
      StringResource("string:final_quiz_corrected_none", "final_quiz_corrected_none", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 165189, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 162585, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 164092, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 156373, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152821, 77),
      ))
    }

@delegate:ResourceContentHash(-715_806_801)
internal val Res.string.final_quiz_corrected_one: StringResource by lazy {
      StringResource("string:final_quiz_corrected_one", "final_quiz_corrected_one", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 165283, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 162683, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 164174, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 156451, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152899, 64),
      ))
    }

@delegate:ResourceContentHash(-1_038_355_082)
internal val Res.string.final_quiz_label_accuracy: StringResource by lazy {
      StringResource("string:final_quiz_label_accuracy", "final_quiz_label_accuracy", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 165348, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 162744, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 164239, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 156512, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 152964, 41),
      ))
    }

@delegate:ResourceContentHash(1_454_320_800)
internal val Res.string.final_quiz_label_exp: StringResource by lazy {
      StringResource("string:final_quiz_label_exp", "final_quiz_label_exp", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 165390, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 162786, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 164285, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 156554, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153006, 32),
      ))
    }

@delegate:ResourceContentHash(-481_109_138)
internal val Res.string.final_quiz_label_time: StringResource by lazy {
      StringResource("string:final_quiz_label_time", "final_quiz_label_time", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 165423, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 162819, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 164318, 37),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 156587, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153039, 37),
      ))
    }

@delegate:ResourceContentHash(-137_079_966)
internal val Res.string.final_quiz_masko_perfect_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_masko_perfect_feedback_1", "final_quiz_masko_perfect_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 165461, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 162857, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 164356, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 156625, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153077, 99),
      ))
    }

@delegate:ResourceContentHash(-2_104_683_934)
internal val Res.string.final_quiz_masko_perfect_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_masko_perfect_feedback_2", "final_quiz_masko_perfect_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 165561, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 162989, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 164460, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 156733, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153177, 127),
      ))
    }

@delegate:ResourceContentHash(617_715_350)
internal val Res.string.final_quiz_masko_stars0_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_masko_stars0_feedback_1", "final_quiz_masko_stars0_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 165681, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 163113, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 164604, 106),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 156873, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153305, 106),
      ))
    }

@delegate:ResourceContentHash(826_765_347)
internal val Res.string.final_quiz_masko_stars0_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_masko_stars0_feedback_2", "final_quiz_masko_stars0_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 165828, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 163240, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 164711, 126),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 156988, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153412, 106),
      ))
    }

@delegate:ResourceContentHash(2_086_179_714)
internal val Res.string.final_quiz_masko_stars1_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_masko_stars1_feedback_1", "final_quiz_masko_stars1_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 165939, 150),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 163343, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 164838, 154),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 157095, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153519, 118),
      ))
    }

@delegate:ResourceContentHash(-1_271_140_095)
internal val Res.string.final_quiz_masko_stars1_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_masko_stars1_feedback_2", "final_quiz_masko_stars1_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 166090, 150),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 163482, 154),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 164993, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 157238, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153638, 138),
      ))
    }

@delegate:ResourceContentHash(2_091_276_814)
internal val Res.string.final_quiz_masko_stars2_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_masko_stars2_feedback_1", "final_quiz_masko_stars2_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 166241, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 163637, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 165136, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 157377, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153777, 94),
      ))
    }

@delegate:ResourceContentHash(-1_589_064_163)
internal val Res.string.final_quiz_masko_stars2_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_masko_stars2_feedback_2", "final_quiz_masko_stars2_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 166336, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 163752, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 165231, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 157484, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153872, 110),
      ))
    }

@delegate:ResourceContentHash(-667_679_257)
internal val Res.string.final_quiz_masko_stars3_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_masko_stars3_feedback_1", "final_quiz_masko_stars3_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 166467, 142),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 163879, 154),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 165362, 150),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 157603, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153983, 138),
      ))
    }

@delegate:ResourceContentHash(-1_357_145_011)
internal val Res.string.final_quiz_masko_stars3_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_masko_stars3_feedback_2", "final_quiz_masko_stars3_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 166610, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 164034, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 165513, 102),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 157746, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154122, 94),
      ))
    }

@delegate:ResourceContentHash(-205_047_466)
internal val Res.string.final_quiz_nilo_perfect_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_nilo_perfect_feedback_1", "final_quiz_nilo_perfect_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 166725, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 164141, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 165616, 134),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 157845, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154217, 114),
      ))
    }

@delegate:ResourceContentHash(-1_310_084_656)
internal val Res.string.final_quiz_nilo_perfect_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_nilo_perfect_feedback_2", "final_quiz_nilo_perfect_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 166832, 154),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 164256, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 165751, 150),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 157968, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154332, 126),
      ))
    }

@delegate:ResourceContentHash(56_386_330)
internal val Res.string.final_quiz_nilo_stars0_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_nilo_stars0_feedback_1", "final_quiz_nilo_stars0_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 166987, 137),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 164391, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 165902, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 158111, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154459, 109),
      ))
    }

@delegate:ResourceContentHash(-261_652_545)
internal val Res.string.final_quiz_nilo_stars0_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_nilo_stars0_feedback_2", "final_quiz_nilo_stars0_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 167125, 137),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 164529, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 166024, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 158233, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154569, 129),
      ))
    }

@delegate:ResourceContentHash(-602_743_033)
internal val Res.string.final_quiz_nilo_stars1_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_nilo_stars1_feedback_1", "final_quiz_nilo_stars1_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 167263, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 164651, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 166174, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 158375, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154699, 137),
      ))
    }

@delegate:ResourceContentHash(635_376_677)
internal val Res.string.final_quiz_nilo_stars1_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_nilo_stars1_feedback_2", "final_quiz_nilo_stars1_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 167417, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 164793, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 166324, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 158533, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154837, 137),
      ))
    }

@delegate:ResourceContentHash(-812_487_671)
internal val Res.string.final_quiz_nilo_stars2_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_nilo_stars2_feedback_1", "final_quiz_nilo_stars2_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 167583, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 164955, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 166482, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 158683, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154975, 105),
      ))
    }

@delegate:ResourceContentHash(-2_008_022_189)
internal val Res.string.final_quiz_nilo_stars2_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_nilo_stars2_feedback_2", "final_quiz_nilo_stars2_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 167697, 137),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 165065, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 166592, 129),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 158789, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155081, 109),
      ))
    }

@delegate:ResourceContentHash(306_563_010)
internal val Res.string.final_quiz_nilo_stars3_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_nilo_stars3_feedback_1", "final_quiz_nilo_stars3_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 167835, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 165175, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 166722, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 158907, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155191, 117),
      ))
    }

@delegate:ResourceContentHash(343_124_395)
internal val Res.string.final_quiz_nilo_stars3_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_nilo_stars3_feedback_2", "final_quiz_nilo_stars3_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 167945, 169),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 165297, 165),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 166844, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 159017, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155309, 141),
      ))
    }

@delegate:ResourceContentHash(932_989_245)
internal val Res.string.final_quiz_zeta_perfect_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_zeta_perfect_feedback_1", "final_quiz_zeta_perfect_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 168115, 150),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 165463, 150),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 167002, 166),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 159159, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155451, 134),
      ))
    }

@delegate:ResourceContentHash(1_583_222_493)
internal val Res.string.final_quiz_zeta_perfect_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_zeta_perfect_feedback_2", "final_quiz_zeta_perfect_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 168266, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 165614, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 167169, 110),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 159318, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155586, 114),
      ))
    }

@delegate:ResourceContentHash(421_274_221)
internal val Res.string.final_quiz_zeta_stars0_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_zeta_stars0_feedback_1", "final_quiz_zeta_stars0_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 168397, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 165733, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 167280, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 159429, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155701, 137),
      ))
    }

@delegate:ResourceContentHash(2_091_480_218)
internal val Res.string.final_quiz_zeta_stars0_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_zeta_stars0_feedback_2", "final_quiz_zeta_stars0_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 168551, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 165875, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 167438, 141),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 159575, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155839, 133),
      ))
    }

@delegate:ResourceContentHash(2_110_232_593)
internal val Res.string.final_quiz_zeta_stars1_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_zeta_stars1_feedback_1", "final_quiz_zeta_stars1_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 168685, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 166005, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 167580, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 159713, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 155973, 133),
      ))
    }

@delegate:ResourceContentHash(-920_666_566)
internal val Res.string.final_quiz_zeta_stars1_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_zeta_stars1_feedback_2", "final_quiz_zeta_stars1_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 168831, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 166151, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 167714, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 159843, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156107, 125),
      ))
    }

@delegate:ResourceContentHash(2_058_156_331)
internal val Res.string.final_quiz_zeta_stars2_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_zeta_stars2_feedback_1", "final_quiz_zeta_stars2_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 168981, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 166297, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 167868, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 159985, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156233, 101),
      ))
    }

@delegate:ResourceContentHash(532_853_262)
internal val Res.string.final_quiz_zeta_stars2_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_zeta_stars2_feedback_2", "final_quiz_zeta_stars2_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169095, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 166391, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 167978, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160079, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156335, 85),
      ))
    }

@delegate:ResourceContentHash(1_249_220_409)
internal val Res.string.final_quiz_zeta_stars3_feedback_1: StringResource by lazy {
      StringResource("string:final_quiz_zeta_stars3_feedback_1", "final_quiz_zeta_stars3_feedback_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169193, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 166481, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168060, 141),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160157, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156421, 133),
      ))
    }

@delegate:ResourceContentHash(-667_276_453)
internal val Res.string.final_quiz_zeta_stars3_feedback_2: StringResource by lazy {
      StringResource("string:final_quiz_zeta_stars3_feedback_2", "final_quiz_zeta_stars3_feedback_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169327, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 166627, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168202, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160307, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156555, 137),
      ))
    }

@delegate:ResourceContentHash(-1_780_608_860)
internal val Res.string.fine_btn: StringResource by lazy {
      StringResource("string:fine_btn", "fine_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169485, 24),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 166785, 20),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168356, 28),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160453, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156693, 24),
      ))
    }

@delegate:ResourceContentHash(-1_394_431_444)
internal val Res.string.full_version_active_btn: StringResource by lazy {
      StringResource("string:full_version_active_btn", "full_version_active_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169510, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 166806, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168385, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160478, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156718, 47),
      ))
    }

@delegate:ResourceContentHash(-55_687_304)
internal val Res.string.full_version_btn: StringResource by lazy {
      StringResource("string:full_version_btn", "full_version_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169554, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 166854, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168429, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160526, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156766, 40),
      ))
    }

@delegate:ResourceContentHash(-1_661_552_910)
internal val Res.string.haptic_settings_desc: StringResource by lazy {
      StringResource("string:haptic_settings_desc", "haptic_settings_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169595, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 166903, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168478, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160575, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156807, 60),
      ))
    }

@delegate:ResourceContentHash(2_081_791_939)
internal val Res.string.haptic_settings_title: StringResource by lazy {
      StringResource("string:haptic_settings_title", "haptic_settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169668, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 166972, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168543, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160648, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156868, 41),
      ))
    }

@delegate:ResourceContentHash(331_082_397)
internal val Res.string.header_type_combo_five: StringResource by lazy {
      StringResource("string:header_type_combo_five", "header_type_combo_five", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169710, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167018, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168585, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160694, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156910, 62),
      ))
    }

@delegate:ResourceContentHash(523_213_126)
internal val Res.string.header_type_final_quiz: StringResource by lazy {
      StringResource("string:header_type_final_quiz", "header_type_final_quiz", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169773, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167085, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168648, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160757, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 156973, 50),
      ))
    }

@delegate:ResourceContentHash(179_656_242)
internal val Res.string.header_type_multi_selection: StringResource by lazy {
      StringResource("string:header_type_multi_selection", "header_type_multi_selection", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169832, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167136, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168699, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160804, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157024, 55),
      ))
    }

@delegate:ResourceContentHash(-390_094_250)
internal val Res.string.header_type_phonetic_keyboard: StringResource by lazy {
      StringResource("string:header_type_phonetic_keyboard", "header_type_phonetic_keyboard", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169888, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167196, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168755, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160864, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157080, 69),
      ))
    }

@delegate:ResourceContentHash(-196_302_679)
internal val Res.string.header_type_single_selection: StringResource by lazy {
      StringResource("string:header_type_single_selection", "header_type_single_selection", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169958, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167266, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168821, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160934, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157150, 56),
      ))
    }

@delegate:ResourceContentHash(1_149_621_326)
internal val Res.string.header_type_text_translation: StringResource by lazy {
      StringResource("string:header_type_text_translation", "header_type_text_translation", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170015, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167327, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168874, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 160991, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157207, 60),
      ))
    }

@delegate:ResourceContentHash(1_559_591_944)
internal val Res.string.header_type_three_errors: StringResource by lazy {
      StringResource("string:header_type_three_errors", "header_type_three_errors", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170080, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167388, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 168935, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161052, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157268, 64),
      ))
    }

@delegate:ResourceContentHash(1_316_011_380)
internal val Res.string.header_type_true_false: StringResource by lazy {
      StringResource("string:header_type_true_false", "header_type_true_false", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170141, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167453, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169000, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161113, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157333, 50),
      ))
    }

@delegate:ResourceContentHash(844_612_909)
internal val Res.string.header_type_word_selection: StringResource by lazy {
      StringResource("string:header_type_word_selection", "header_type_word_selection", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170196, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167512, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169051, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161164, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157384, 58),
      ))
    }

@delegate:ResourceContentHash(494_262_966)
internal val Res.string.hide_options_desc: StringResource by lazy {
      StringResource("string:hide_options_desc", "hide_options_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170251, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167571, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169114, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161223, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157443, 109),
      ))
    }

@delegate:ResourceContentHash(334_953_050)
internal val Res.string.hide_options_title: StringResource by lazy {
      StringResource("string:hide_options_title", "hide_options_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170369, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167677, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169224, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161333, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157553, 42),
      ))
    }

@delegate:ResourceContentHash(-1_812_407_126)
internal val Res.string.hiero_detail_title: StringResource by lazy {
      StringResource("string:hiero_detail_title", "hiero_detail_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170424, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167728, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169279, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161384, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157596, 46),
      ))
    }

@delegate:ResourceContentHash(1_448_359_745)
internal val Res.string.hiero_not_seen_hint: StringResource by lazy {
      StringResource("string:hiero_not_seen_hint", "hiero_not_seen_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170475, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167779, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169330, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161435, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157643, 79),
      ))
    }

@delegate:ResourceContentHash(-332_123_167)
internal val Res.string.hint_btn: StringResource by lazy {
      StringResource("string:hint_btn", "hint_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170563, 24),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167863, 24),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169422, 24),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161519, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157723, 24),
      ))
    }

@delegate:ResourceContentHash(-911_945_044)
internal val Res.string.ho_capito_btn: StringResource by lazy {
      StringResource("string:ho_capito_btn", "ho_capito_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170588, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167888, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169447, 37),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161548, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157748, 37),
      ))
    }

@delegate:ResourceContentHash(-1_992_148_424)
internal val Res.string.image_popup_credit: StringResource by lazy {
      StringResource("string:image_popup_credit", "image_popup_credit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170626, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167922, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169485, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161582, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157786, 42),
      ))
    }

@delegate:ResourceContentHash(1_233_997_950)
internal val Res.string.impara_btn: StringResource by lazy {
      StringResource("string:impara_btn", "impara_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170669, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167965, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169532, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161625, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157829, 26),
      ))
    }

@delegate:ResourceContentHash(-104_185_510)
internal val Res.string.inizia_btn: StringResource by lazy {
      StringResource("string:inizia_btn", "inizia_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170696, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 167996, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169563, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161652, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157856, 26),
      ))
    }

@delegate:ResourceContentHash(604_628_029)
internal val Res.string.inscription_name_ri00200: StringResource by lazy {
      StringResource("string:inscription_name_ri00200", "inscription_name_ri00200", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170723, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 168027, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169594, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161679, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157883, 80),
      ))
    }

@delegate:ResourceContentHash(266_294_694)
internal val Res.string.intro_btn_next: StringResource by lazy {
      StringResource("string:intro_btn_next", "intro_btn_next", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170804, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 168108, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169675, 34),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161764, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157964, 30),
      ))
    }

@delegate:ResourceContentHash(-1_583_602_514)
internal val Res.string.intro_btn_request_notifications: StringResource by lazy {
      StringResource("string:intro_btn_request_notifications", "intro_btn_request_notifications", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170835, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 168143, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169710, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161795, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157995, 67),
      ))
    }

@delegate:ResourceContentHash(756_659_971)
internal val Res.string.intro_btn_request_timer: StringResource by lazy {
      StringResource("string:intro_btn_request_timer", "intro_btn_request_timer", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170915, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 168215, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169786, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161859, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158063, 47),
      ))
    }

@delegate:ResourceContentHash(-1_337_161_845)
internal val Res.string.intro_msg_1: StringResource by lazy {
      StringResource("string:intro_msg_1", "intro_msg_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 171412, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 168788, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 170347, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 162372, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158556, 43),
      ))
    }

@delegate:ResourceContentHash(14_038_384)
internal val Res.string.intro_msg_10: StringResource by lazy {
      StringResource("string:intro_msg_10", "intro_msg_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 170967, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 168275, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169846, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161911, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158111, 88),
      ))
    }

@delegate:ResourceContentHash(731_566_603)
internal val Res.string.intro_msg_14: StringResource by lazy {
      StringResource("string:intro_msg_14", "intro_msg_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 171060, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 168388, 160),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169951, 152),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 162020, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158200, 148),
      ))
    }

@delegate:ResourceContentHash(1_263_122_605)
internal val Res.string.intro_msg_17: StringResource by lazy {
      StringResource("string:intro_msg_17", "intro_msg_17", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 171193, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 168549, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 170104, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 162153, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158349, 52),
      ))
    }

@delegate:ResourceContentHash(-1_901_972_004)
internal val Res.string.intro_msg_18: StringResource by lazy {
      StringResource("string:intro_msg_18", "intro_msg_18", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 171250, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 168602, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 170165, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 162206, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158402, 84),
      ))
    }

@delegate:ResourceContentHash(1_498_329_662)
internal val Res.string.intro_msg_19: StringResource by lazy {
      StringResource("string:intro_msg_19", "intro_msg_19", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 171331, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 168711, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 170262, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 162303, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158487, 68),
      ))
    }

@delegate:ResourceContentHash(-901_465_601)
internal val Res.string.intro_msg_2: StringResource by lazy {
      StringResource("string:intro_msg_2", "intro_msg_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 171884, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169240, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 170827, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 162784, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158976, 83),
      ))
    }

@delegate:ResourceContentHash(1_654_245_283)
internal val Res.string.intro_msg_20: StringResource by lazy {
      StringResource("string:intro_msg_20", "intro_msg_20", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 171456, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 168848, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 170395, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 162416, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158600, 28),
      ))
    }

@delegate:ResourceContentHash(1_834_544_221)
internal val Res.string.intro_msg_21: StringResource by lazy {
      StringResource("string:intro_msg_21", "intro_msg_21", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 171485, 204),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 168885, 168),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 170428, 196),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 162445, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158629, 172),
      ))
    }

@delegate:ResourceContentHash(1_898_791_064)
internal val Res.string.intro_msg_22: StringResource by lazy {
      StringResource("string:intro_msg_22", "intro_msg_22", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 171690, 148),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169054, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 170625, 156),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 162602, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158802, 124),
      ))
    }

@delegate:ResourceContentHash(232_773_818)
internal val Res.string.intro_msg_23: StringResource by lazy {
      StringResource("string:intro_msg_23", "intro_msg_23", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 171839, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169195, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 170782, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 162743, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158927, 48),
      ))
    }

@delegate:ResourceContentHash(-933_258_174)
internal val Res.string.intro_msg_3: StringResource by lazy {
      StringResource("string:intro_msg_3", "intro_msg_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 171964, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169324, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 170927, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 162868, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159060, 91),
      ))
    }

@delegate:ResourceContentHash(-1_442_041_633)
internal val Res.string.intro_msg_4: StringResource by lazy {
      StringResource("string:intro_msg_4", "intro_msg_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172052, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169416, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171043, 35),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 162968, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159152, 31),
      ))
    }

@delegate:ResourceContentHash(-1_442_591_745)
internal val Res.string.intro_msg_5: StringResource by lazy {
      StringResource("string:intro_msg_5", "intro_msg_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172088, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169452, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171079, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 162996, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159184, 67),
      ))
    }

@delegate:ResourceContentHash(967_557_582)
internal val Res.string.intro_msg_6: StringResource by lazy {
      StringResource("string:intro_msg_6", "intro_msg_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172160, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169528, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171151, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163068, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159252, 67),
      ))
    }

@delegate:ResourceContentHash(-1_455_134_155)
internal val Res.string.intro_msg_7: StringResource by lazy {
      StringResource("string:intro_msg_7", "intro_msg_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 172228, 27),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 169608, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 171231, 31),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 163136, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159320, 27),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString15Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_poll_subtitle", Res.string.feature_poll_subtitle)
  map.put("feature_poll_title", Res.string.feature_poll_title)
  map.put("feature_unavailable_ok", Res.string.feature_unavailable_ok)
  map.put("feature_unavailable_web_text", Res.string.feature_unavailable_web_text)
  map.put("feature_unavailable_web_title", Res.string.feature_unavailable_web_title)
  map.put("feedback_general_subject", Res.string.feedback_general_subject)
  map.put("feedback_general_template", Res.string.feedback_general_template)
  map.put("feedback_quiz_error_subject", Res.string.feedback_quiz_error_subject)
  map.put("feedback_quiz_error_template", Res.string.feedback_quiz_error_template)
  map.put("feedback_update_issue_subject", Res.string.feedback_update_issue_subject)
  map.put("feedback_update_issue_template", Res.string.feedback_update_issue_template)
  map.put("final_quiz_alyn_perfect_feedback_1", Res.string.final_quiz_alyn_perfect_feedback_1)
  map.put("final_quiz_alyn_perfect_feedback_2", Res.string.final_quiz_alyn_perfect_feedback_2)
  map.put("final_quiz_alyn_stars0_feedback_1", Res.string.final_quiz_alyn_stars0_feedback_1)
  map.put("final_quiz_alyn_stars0_feedback_2", Res.string.final_quiz_alyn_stars0_feedback_2)
  map.put("final_quiz_alyn_stars1_feedback_1", Res.string.final_quiz_alyn_stars1_feedback_1)
  map.put("final_quiz_alyn_stars1_feedback_2", Res.string.final_quiz_alyn_stars1_feedback_2)
  map.put("final_quiz_alyn_stars2_feedback_1", Res.string.final_quiz_alyn_stars2_feedback_1)
  map.put("final_quiz_alyn_stars2_feedback_2", Res.string.final_quiz_alyn_stars2_feedback_2)
  map.put("final_quiz_alyn_stars3_feedback_1", Res.string.final_quiz_alyn_stars3_feedback_1)
  map.put("final_quiz_alyn_stars3_feedback_2", Res.string.final_quiz_alyn_stars3_feedback_2)
  map.put("final_quiz_corrected_many", Res.string.final_quiz_corrected_many)
  map.put("final_quiz_corrected_none", Res.string.final_quiz_corrected_none)
  map.put("final_quiz_corrected_one", Res.string.final_quiz_corrected_one)
  map.put("final_quiz_label_accuracy", Res.string.final_quiz_label_accuracy)
  map.put("final_quiz_label_exp", Res.string.final_quiz_label_exp)
  map.put("final_quiz_label_time", Res.string.final_quiz_label_time)
  map.put("final_quiz_masko_perfect_feedback_1", Res.string.final_quiz_masko_perfect_feedback_1)
  map.put("final_quiz_masko_perfect_feedback_2", Res.string.final_quiz_masko_perfect_feedback_2)
  map.put("final_quiz_masko_stars0_feedback_1", Res.string.final_quiz_masko_stars0_feedback_1)
  map.put("final_quiz_masko_stars0_feedback_2", Res.string.final_quiz_masko_stars0_feedback_2)
  map.put("final_quiz_masko_stars1_feedback_1", Res.string.final_quiz_masko_stars1_feedback_1)
  map.put("final_quiz_masko_stars1_feedback_2", Res.string.final_quiz_masko_stars1_feedback_2)
  map.put("final_quiz_masko_stars2_feedback_1", Res.string.final_quiz_masko_stars2_feedback_1)
  map.put("final_quiz_masko_stars2_feedback_2", Res.string.final_quiz_masko_stars2_feedback_2)
  map.put("final_quiz_masko_stars3_feedback_1", Res.string.final_quiz_masko_stars3_feedback_1)
  map.put("final_quiz_masko_stars3_feedback_2", Res.string.final_quiz_masko_stars3_feedback_2)
  map.put("final_quiz_nilo_perfect_feedback_1", Res.string.final_quiz_nilo_perfect_feedback_1)
  map.put("final_quiz_nilo_perfect_feedback_2", Res.string.final_quiz_nilo_perfect_feedback_2)
  map.put("final_quiz_nilo_stars0_feedback_1", Res.string.final_quiz_nilo_stars0_feedback_1)
  map.put("final_quiz_nilo_stars0_feedback_2", Res.string.final_quiz_nilo_stars0_feedback_2)
  map.put("final_quiz_nilo_stars1_feedback_1", Res.string.final_quiz_nilo_stars1_feedback_1)
  map.put("final_quiz_nilo_stars1_feedback_2", Res.string.final_quiz_nilo_stars1_feedback_2)
  map.put("final_quiz_nilo_stars2_feedback_1", Res.string.final_quiz_nilo_stars2_feedback_1)
  map.put("final_quiz_nilo_stars2_feedback_2", Res.string.final_quiz_nilo_stars2_feedback_2)
  map.put("final_quiz_nilo_stars3_feedback_1", Res.string.final_quiz_nilo_stars3_feedback_1)
  map.put("final_quiz_nilo_stars3_feedback_2", Res.string.final_quiz_nilo_stars3_feedback_2)
  map.put("final_quiz_zeta_perfect_feedback_1", Res.string.final_quiz_zeta_perfect_feedback_1)
  map.put("final_quiz_zeta_perfect_feedback_2", Res.string.final_quiz_zeta_perfect_feedback_2)
  map.put("final_quiz_zeta_stars0_feedback_1", Res.string.final_quiz_zeta_stars0_feedback_1)
  map.put("final_quiz_zeta_stars0_feedback_2", Res.string.final_quiz_zeta_stars0_feedback_2)
  map.put("final_quiz_zeta_stars1_feedback_1", Res.string.final_quiz_zeta_stars1_feedback_1)
  map.put("final_quiz_zeta_stars1_feedback_2", Res.string.final_quiz_zeta_stars1_feedback_2)
  map.put("final_quiz_zeta_stars2_feedback_1", Res.string.final_quiz_zeta_stars2_feedback_1)
  map.put("final_quiz_zeta_stars2_feedback_2", Res.string.final_quiz_zeta_stars2_feedback_2)
  map.put("final_quiz_zeta_stars3_feedback_1", Res.string.final_quiz_zeta_stars3_feedback_1)
  map.put("final_quiz_zeta_stars3_feedback_2", Res.string.final_quiz_zeta_stars3_feedback_2)
  map.put("fine_btn", Res.string.fine_btn)
  map.put("full_version_active_btn", Res.string.full_version_active_btn)
  map.put("full_version_btn", Res.string.full_version_btn)
  map.put("haptic_settings_desc", Res.string.haptic_settings_desc)
  map.put("haptic_settings_title", Res.string.haptic_settings_title)
  map.put("header_type_combo_five", Res.string.header_type_combo_five)
  map.put("header_type_final_quiz", Res.string.header_type_final_quiz)
  map.put("header_type_multi_selection", Res.string.header_type_multi_selection)
  map.put("header_type_phonetic_keyboard", Res.string.header_type_phonetic_keyboard)
  map.put("header_type_single_selection", Res.string.header_type_single_selection)
  map.put("header_type_text_translation", Res.string.header_type_text_translation)
  map.put("header_type_three_errors", Res.string.header_type_three_errors)
  map.put("header_type_true_false", Res.string.header_type_true_false)
  map.put("header_type_word_selection", Res.string.header_type_word_selection)
  map.put("hide_options_desc", Res.string.hide_options_desc)
  map.put("hide_options_title", Res.string.hide_options_title)
  map.put("hiero_detail_title", Res.string.hiero_detail_title)
  map.put("hiero_not_seen_hint", Res.string.hiero_not_seen_hint)
  map.put("hint_btn", Res.string.hint_btn)
  map.put("ho_capito_btn", Res.string.ho_capito_btn)
  map.put("image_popup_credit", Res.string.image_popup_credit)
  map.put("impara_btn", Res.string.impara_btn)
  map.put("inizia_btn", Res.string.inizia_btn)
  map.put("inscription_name_ri00200", Res.string.inscription_name_ri00200)
  map.put("intro_btn_next", Res.string.intro_btn_next)
  map.put("intro_btn_request_notifications", Res.string.intro_btn_request_notifications)
  map.put("intro_btn_request_timer", Res.string.intro_btn_request_timer)
  map.put("intro_msg_1", Res.string.intro_msg_1)
  map.put("intro_msg_10", Res.string.intro_msg_10)
  map.put("intro_msg_14", Res.string.intro_msg_14)
  map.put("intro_msg_17", Res.string.intro_msg_17)
  map.put("intro_msg_18", Res.string.intro_msg_18)
  map.put("intro_msg_19", Res.string.intro_msg_19)
  map.put("intro_msg_2", Res.string.intro_msg_2)
  map.put("intro_msg_20", Res.string.intro_msg_20)
  map.put("intro_msg_21", Res.string.intro_msg_21)
  map.put("intro_msg_22", Res.string.intro_msg_22)
  map.put("intro_msg_23", Res.string.intro_msg_23)
  map.put("intro_msg_3", Res.string.intro_msg_3)
  map.put("intro_msg_4", Res.string.intro_msg_4)
  map.put("intro_msg_5", Res.string.intro_msg_5)
  map.put("intro_msg_6", Res.string.intro_msg_6)
  map.put("intro_msg_7", Res.string.intro_msg_7)
}
